(() => {
  'use strict'

  if (window.LCSB2BFunnelTracking) return
  window.LCSB2BFunnelTracking = true

  const observed = new WeakSet()
  const started = new WeakSet()
  const lastSubmitAttempt = new WeakMap()

  function marketingAllowed() {
    try {
      return Boolean(window.Shopify?.customerPrivacy?.marketingAllowed())
    } catch (_) {
      return false
    }
  }

  function publish(event, formType, extra = {}) {
    if (!marketingAllowed()) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event,
      lcs_form_type: formType,
      lcs_page_path: location.pathname,
      ...extra
    })
  }

  function formType(element) {
    if (element?.closest('#QuoteRequestForm')) return 'quote_request'
    if (element?.closest('#bss-b2b-registration-form')) return 'pro_account'
    return ''
  }

  function publishSubmitAttempt(element, type) {
    const container = element?.closest('#QuoteRequestForm, #bss-b2b-registration-form') || element
    if (!container) return
    const now = Date.now()
    if (now - (lastSubmitAttempt.get(container) || 0) < 1000) return
    lastSubmitAttempt.set(container, now)
    publish('lcs_b2b_form_submit_attempt', type)
  }

  function observeForm(element, type) {
    if (!element || observed.has(element)) return
    observed.add(element)
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        publish('lcs_b2b_form_view', type)
        observer.disconnect()
      }
    }, { threshold: 0.25 })
    observer.observe(element)
  }

  function discoverForms() {
    observeForm(document.querySelector('#QuoteRequestForm'), 'quote_request')
    observeForm(document.querySelector('#bss-b2b-registration-form'), 'pro_account')
  }

  document.addEventListener('focusin', (event) => {
    const type = formType(event.target)
    const form = event.target?.closest('#QuoteRequestForm, #bss-b2b-registration-form')
    if (!type || !form || started.has(form)) return
    started.add(form)
    publish('lcs_b2b_form_start', type)
  }, true)

  document.addEventListener('submit', (event) => {
    const type = formType(event.target)
    if (type) publishSubmitAttempt(event.target, type)
  }, true)

  document.addEventListener('click', (event) => {
    const submit = event.target?.closest(
      '#bss-b2b-registration-form input[type="submit"], #bss-b2b-registration-form button[type="submit"]'
    )
    if (submit) publishSubmitAttempt(submit, 'pro_account')

    const link = event.target?.closest('a[href]')
    if (!link) return
    const href = link.getAttribute('href') || ''
    if (href === '#ProAccountForm' || href === '#QuoteRequestForm') {
      publish('lcs_b2b_cta_click', href === '#ProAccountForm' ? 'pro_account' : 'quote_request', {
        lcs_cta_target: href.slice(1)
      })
    }
  }, true)

  if (document.querySelector('#QuoteRequestForm .form-status-list')) {
    publish('lcs_b2b_form_success', 'quote_request')
  }

  discoverForms()
  const mutationObserver = new MutationObserver(discoverForms)
  mutationObserver.observe(document.body, { childList: true, subtree: true })
  document.addEventListener('visitorConsentCollected', discoverForms)
})()
